<ng-container [ngSwitch]="colorFilterKeys.includes(filter?.key)">
  <ng-container *ngSwitchCase="true">
    <gd-product-templates-list-item-filter-color [filter]="filter"></gd-product-templates-list-item-filter-color>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <gd-product-templates-list-item-filter-regular [filter]="filter"></gd-product-templates-list-item-filter-regular>
  </ng-container>
</ng-container>
